export default __webpack_public_path__ + "static/media/regulatory--divided-highway-starts--g1.846d4a16.png";